import ready from "./ready";

let $asideFiller

ready(function() {
	$asideFiller = document.querySelector('.js-aside-filler');
	if ($asideFiller) {
		layout()
		window.addEventListener('resize', layout)
	}
})

function layout() {
	$asideFiller.style.height = window.innerHeight - 36 * 2 + 'px'
}